var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconClose = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10.828,
  height: 10.828,
  viewBox: "0 0 14.828 10.828",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_9027",
  "data-name": "Grupo 9027",
  transform: "translate(1.414 1.414)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2661",
  "data-name": "Caminho 2661",
  d: "M1589.524-12216l10,10",
  transform: "translate(-1589.521 12216)",
  fill: "#949494",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_2662",
  "data-name": "Caminho 2662",
  d: "M0,0,10,10",
  transform: "translate(10 0.001) rotate(90)",
  fill: "#949494",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeWidth: 2
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_close.44ba1b6b.svg";
export { ForwardRef as ReactComponent };